import { Utils } from '../shared/utils';
import { UserAddressDto } from '../shared/models/user-address.dto';

export class UserDto {
  public readonly id?: number;
  public readonly email: string;
  public readonly name: string;
  public readonly groups: string[] = [];
  public readonly lastname: string;
  public readonly firstname: string;
  public readonly postalAddresses: UserAddressDto[] = [];
  public readonly structureId?: number;
  public readonly structureLabel?: string;
  public readonly structureMainAddressPhone?: string;
  public readonly cliIds: number[] = [];
  public readonly ctmIds: number[] = [];
  public readonly active: boolean = true;
  public readonly clearances: string[] = [];
  public readonly password?: string;
  public readonly structureAddressIds?: number[] = [];
  public readonly inactiveSince: Date;
  public readonly replacedByUserId: number;

  public static signature(user: UserDto): string | null {
    if (user) {
      let address: UserAddressDto[] = [];
      if (user.postalAddresses && user.postalAddresses.length > 0) {
        address = user.postalAddresses;
      }
      const position: string = address && address.length > 0 ? address[0].position : undefined;
      const telephone: string = address && address.length > 0 ? address[0].telephone : undefined;
      return (
        '<p><br></p>' +
        '<p><br></p>' +
        '<p><strong>' +
        user.name +
        (Utils.isNotEmpty(position) ? '<p><strong style="color: rgb(136, 136, 136);">' + position + '</strong></p>' : '') +
        '<p></p>' +
        '</strong></p>' +
        (Utils.isNotEmpty(telephone) ? '<p><strong  style="color: rgb(136, 136, 136);">' + telephone + '</strong></p>' : '') +
        '</strong></p>' +
        '<p><a href="mailto:' +
        user.email +
        '" target="_blank">' +
        user.email +
        '</a></p>'
      );
    }
    return null;
  }
}
